import styled from '@emotion/styled';
import { colors } from '@/constants/colors';

export const InputWrapDiv = styled.div`
display: flex;
width: 100%;
flex-direction: column;
margin-top: 32px;
gap: 8px;
`;

export const InputAboveDiv = styled.div`
display: flex;
`;

export const InputWrapSpan = styled.div`
display: flex;
color: ${colors.textPrimary};
column-gap: .25em;
font-size: 14px;
font-weight: 700;
line-height: 24px;
`;
